import _store from 'store2'
import {V2MailUnReadNum, V2RequestToAuditList, V2FollowNum, V2ToAuditMailNum, V2TeamList} from '@/api/index'
import {useRoute} from "vue-router";
import sessionStore from "@/utils/sessionStore";
// import { EventEmitterSingle } from '@/utils/EventEmitter.js'

let teamListFetchPromise = null;

const hash = window.location.hash;

// 使用正则表达式匹配查询参数中的teamID值
const match = hash.match(/teamID=([^&]*)/);
let teamID = '';
// 如果匹配到了teamID，则输出其值
if (match) {
    teamID = match[1];
    console.log('fffff', teamID)
}

const email = {
    namespaced: true,
    state: {
        teamID: teamID ? teamID : sessionStore.get('teamId'),
        //团队
        teamList: sessionStore.get("teamList") || [], //团队名称,
        // 是否展示 sidbar
        shouldShowSideBar: sessionStore.get("shouldShowSideBar"),
        teamListLoaded: false, //是否已加载团队列表
        emailCode: {
            Inbox: 1, //收件箱
            Sended: 2, //发件箱/已发送
            Draft: 3, //草稿
            Dustbin: 5, //已删除
            Deleted: 4, //垃圾
            DeletedDeep: 6 //彻底删除
        },
        //     联系人为空时的标识符
        customerFlag: false,
        // true 关闭 false 不关闭
        isClose: sessionStore.get("isClose") || false,
    },
    mutations: {
        setShouldShowSideBar(state, payload) {
            sessionStore.set("shouldShowSideBar", payload)
            state.shouldShowSideBar = payload;
        },
        setIsClose(state, val) {
            state.isClose = val
            sessionStore.set("isClose", val)
        },
        setCustomerFlag(state, val) {
            state.customerFlag = val;
        },
        setTeamList(state, val) {
            state.teamList = val
        },
        setCurTeamID(state, val) {
            const next = val === null || val === undefined ? '' : String(val)
            sessionStore.set('teamId', next)
            state.teamID = next
        },
        setCurTeamMyMemberType(state, val) {
            state.curTeamMyMemberType = val
        },
        //设置我的默认邮箱
        setMyDefaultMailbox(state, val) {
            state.defaultMailbox = val
        },
        //设置我的邮箱列表
        setMyUserEmailList(state, val) {
            state.myUserEmailList = val
        },
        setSelectTeamMembers_Admin(state, val) {
            state.selectTeamMembers_Admin = val
        },
        setSelectMember_Admin(state, val) {
            state.selectMember_Admin = val
            state.selectMemberEmail_Admin = '' //切换用户同时，清空已选中邮箱
        },
        setSelectMemberEmail_Admin(state, val) {
            state.selectMemberEmail_Admin = val
        },
        setselectMembersEmailList_Admin(state, val) {
            state.selectMembersEmailList_Admin = val
        },
        setNBarUnreadMailNum(state, val) {
            state.nBarUnreadMailNum = val
            // _store('nBarUnreadMailNum', val || 0)
        },
        setCurTeamInfo(state, val) {
            state.curTeamInfo = val
        }
    },
    actions: {
        async switchTeam({commit, dispatch, rootState}, payload = {}) {
            const nextTeamId = payload?.teamId
            const tabIndex = payload?.tabIndex
            const manageLoading = payload?.manageLoading ?? true
            if (!nextTeamId) return

            if (manageLoading) {
                commit('system/setGlobalLoading', true, {root: true})
            }
            try {
                await commit('setCurTeamID', nextTeamId)
                if (tabIndex !== undefined) {
                    await sessionStore.set('tabIndex', tabIndex)
                }

                await dispatch('user/checkUserInfoIsAdmin', {teamId: nextTeamId, isUpdate: true}, {root: true})

                try {
                    await dispatch('countshow/getTeamAllDataApis', {teamId: nextTeamId}, {root: true})
                } catch (e) {
                }
                try {
                    const userId = rootState?.user?.userInfo?.id
                    // 确保 userId 有效后再调用，避免切换账号时出现"用户id不能为空"错误
                    if (userId && userId !== 0 && userId !== '0' && userId !== 'undefined' && userId !== 'null') {
                        await dispatch('sidebar/getEmailGroupFileAllList', {teamId: nextTeamId, userId}, {root: true})
                    } else {
                        console.warn('switchTeam: userId is invalid, skipping getEmailGroupFileAllList')
                    }
                } catch (e) {
                    console.error('switchTeam: getEmailGroupFileAllList error', e)
                }
            } finally {
                if (manageLoading) {
                    commit('system/setGlobalLoading', false, {root: true})
                }
            }
        },
        resetTeam({state, rootState, commit, dispatch}, teamID) {
            let myUserID = rootState.user.userInfo.userID
            // state.teamID = teamID || 0
            state.defaultMailbox = myUserID
            state.myUserEmailList = []
            state.curTeamMyMemberType = 0
            state.selectMember_Admin = myUserID
            state.selectTeamMembers_Admin = []
            state.selectMemberEmail_Admin = ''
            state.selectMembersEmailList_Admin = []
            state.EmailUnReadNum = 0
        },
        //新增邮箱
        newEmail({state, rootState, commit, dispatch}, addEmail) {
            // console.log('newEmail')
            let myUserID = rootState.user.userInfo.userID
            if (state.selectMember_Admin == myUserID) {
                dispatch('getSelectMembersEmailList_Admin', myUserID)
            }
        },
        //邮箱解绑
        unbundlingEmail({state, rootState, commit, dispatch}, deletedEmail) {
            // console.log('unbundlingEmail')
            //解绑邮箱正好是当前我正在使用邮箱
            if (state.defaultMailbox === deletedEmail) state.defaultMailbox = '' //清空默认邮箱
            if (deletedEmail == state.selectMemberEmail_Admin) state.selectMemberEmail_Admin = ''

            //有可能更新了默认邮箱 刷新成员列表
            dispatch('getSelectTeamMembers_Admin')
            //重新获取邮箱列表
            dispatch('getSelectMembersEmailList_Admin', state.selectMember_Admin)
        },
        // 获取选中团队成员的邮件列表
        async getSelectMembersEmailList_Admin({state, commit, rootState}, userID) {
            state.selectMember_Admin = userID
            let p = api.V2MemberMailboxList({teamID: state.teamID, userID, t: +new Date()})
            p.then(res => {
                state.selectMembersEmailList_Admin = res.data
                console.error('state.selectMembersEmailList_Admin', state.selectMembersEmailList_Admin)
                if (userID === rootState.user.userInfo.userID) {
                    // console.log('保存我自己的邮件列表')
                    state.myUserEmailList = res.data
                    let one = res.data.find(o => o.defaultMailbox)
                    state.defaultMailbox = one ? one.mailAddress : '' //我的默认 邮箱
                }
            })
            return p
        },
        //获取当前团队我的邮箱信息
        async getMySelectMembersEmailList({state, rootState}) {
            let userID = rootState.user.userInfo.userID
            let p = api.V2MemberMailboxList({teamID: state.teamID, userID, t: +new Date()})
            p.then(res => {
                state.myUserEmailList = res.data
                let one = res.data.find(o => o.defaultMailbox)
                state.defaultMailbox = one ? one.mailAddress : '' //我的默认邮箱
                if (state.selectMemberEmail_Admin === userID) state.selectMembersEmailList_Admin = res.data
            })
            return p
        },
        //获取团队成员信息列表
        getSelectTeamMembers_Admin({state, rootState, commit, dispatch}) {
            let p = api.V2InchangeMemberList({id: state.teamID})
            p.then(res => {
                let myUserID = rootState.user.userInfo.userID
                state.selectTeamMembers_Admin = res.data //获取当前团队成员列表
                let {memberType} = res.data.find(o => o.userID == myUserID)
                state.curTeamMyMemberType = memberType //设置我的权限
            })
            return p
        },
        //获取团队--所有
        async getTeamList({state, commit, dispatch, rootState}, payload) {
            const isUpdate = payload?.isUpdate ?? false;

            // --- 1. 从 sessionStore 获取本地 teamList 和 teamId ---
            const localTeamList = sessionStore.get("teamList") || [];
            let storedTeamId = sessionStore.get("teamId") || "";

            const shouldFetch = isUpdate || localTeamList.length === 0;

            // --- 0. 并发去重：同一时刻多处 dispatch 只发起一次请求 ---
            if (shouldFetch && !isUpdate && teamListFetchPromise) {
                return teamListFetchPromise;
            }

            if (!shouldFetch) {
                // 本地已有数据，无需请求
                state.teamList = localTeamList;
                state.teamID = storedTeamId;
                state.teamListLoaded = true;
                return;
            }

            // --- 2. 拉取团队列表 ---
            try {
                let result;
                if (isUpdate) {
                    result = await V2TeamList();
                } else {
                    teamListFetchPromise = Promise.resolve(V2TeamList());
                    result = await teamListFetchPromise;
                }
                const records = result.result || [];

                // --- 3. 设置默认 teamId（大整数统一为字符串） ---
                if (records.length > 0) {
                    const storedExists = storedTeamId && records.some(t => String(t?.id) === String(storedTeamId));
                    if (!storedExists) {
                        storedTeamId = String(records[0].id);
                        sessionStore.set("teamId", storedTeamId);
                    } else {
                        storedTeamId = String(storedTeamId);
                    }
                }
                state.teamID = storedTeamId;

                // --- 4. 处理团队名称 teamNameC ---
                const processTeamName = (name) => {
                    // 防御性检查：如果 name 为 null、undefined 或不是字符串，返回空字符串
                    if (!name || typeof name !== 'string') {
                        return '';
                    }
                    
                    let arr = name.split("");
                    let str = "";
                    let size = 0;

                    while (arr.length > 0 && size < 6) {
                        const char = arr.shift();
                        if (/[\u4E00-\u9FA5]/.test(char)) {
                            if (size + 2 > 6) break;
                            size += 2;
                        } else {
                            size += 1;
                        }
                        str += char;
                    }
                    return str;
                };

                records.forEach(el => {
                    el.teamNameC = processTeamName(el.name);
                    el.teamNumbers = [];
                });

                // --- 5. 写入 state + sessionStore ---
                state.teamList = records;
                state.teamListLoaded = true;
                sessionStore.set("teamList", records);

            } catch (e) {
                console.error("获取团队列表失败:", e);
                throw e;
            } finally {
                if (!isUpdate) teamListFetchPromise = null;
            }
        },
        //收件箱未读数
        async getEmailUnReadNum({state, commit, rootState}) {
            let teamID = state.teamID
            if (teamID && state.selectMember_Admin) {
                let {data} = await V2MailUnReadNum({
                    teamID,
                    userID: state.selectMember_Admin
                })
                state.EmailUnReadNum = data
                // EventEmitter.emit('refreshTeamData')
            } else {
                state.EmailUnReadNum = 0
            }
        },
        //邮件审核数
        async getAuditMailNum({state, commit, rootState}) {
            let teamID = state.teamID
            if (teamID) {
                let {data} = await V2ToAuditMailNum({
                    id: teamID
                })
                state.auditMailNum = data
                // EventEmitter.emit('refreshTeamData')
            } else {
                state.auditMailNum = 0
            }
        },
        //客户领用审核数
        async getRequestToAuditSum({state, commit, rootState}) {
            let teamID = state.teamID
            if (teamID) {
                let {data} = await V2RequestToAuditList({
                    id: teamID
                })
                state.RequestToAuditSum = data
                // EventEmitter.emit('refreshTeamData')
            } else {
                state.RequestToAuditSum = 0
            }
        },
        //领用审核数
        async getFollowNum({state, commit, rootState}) {
            let teamID = state.teamID
            if (teamID) {
                let {
                    data: {mailFollowNum, customerFollowNum}
                } = await V2FollowNum({
                    id: teamID
                })
                state.mailFollowNum = mailFollowNum
                state.customerFollowNum = customerFollowNum
                // EventEmitter.emit('refreshTeamData')
            } else {
                state.mailFollowNum = 0
                state.customerFollowNum = 0
            }
        }
    }
}

export default email
